import React from 'react';
import InfoListingPage from '../components/InfoListingPage';

const items = [
  {
    title: 'City Centre',
    distance: 'A short walk from the hotel',
    image: 'CityCentre.jpg',
    description: 'Explore Plymouth city centre for high street shopping, local businesses, cafés, and everything you need just moments from Grosvenor Plymouth.'
  },
  {
    title: 'Drake Circus',
    distance: 'Close to the hotel',
    image: 'DrakeCircus.jpg',
    description: 'Drake Circus is one of Plymouth’s most popular shopping destinations, offering well-known brands, fashion, dining, and convenient city-centre access.'
  },
  {
    title: 'The Barbican',
    distance: 'Nearby the hotel',
    image: 'TheBarbican.jpg',
    description: 'The Barbican offers a unique shopping experience with charming streets, independent boutiques, galleries, gift shops, and waterside atmosphere.'
  },
  {
    title: 'Plymouth Market',
    distance: '0.6 miles from the hotel',
    image: 'PlymouthMarket.jpg',
    description: 'Plymouth Market is a lively place to browse fresh produce, artisan stalls, speciality goods, and casual food all under one roof.'
  },
  {
    title: 'Royal William Yard',
    distance: '0.6 miles from the hotel',
    image: 'RoyalWilliamYard.jpg',
    description: 'Royal William Yard combines waterside charm with stylish independent businesses, restaurants, and leisure experiences in one of Plymouth’s most iconic settings.'
  }
];

const Shopping = () => (
  <InfoListingPage
    title="Shopping"
    description="Enjoy some of the best shopping spots around Plymouth, from city-centre favourites to independent waterside destinations."
    items={items}
  />
);

export default Shopping;
